import { Box, Text } from '@chakra-ui/core'
import LocaleText from 'components/LocaleText'
import { RootState } from 'constants/interfaces'
import React, { memo, useMemo } from 'react'
import { useSelector } from 'react-redux'
import { useInlineSettings } from '../../../contexts/InlineSettingsContext'

interface DayCircleProps {
  day: string
  isSelected: boolean
  isInRange?: boolean
  onClick: () => void
}

export const DayCircle: React.FC<DayCircleProps> = memo(({ day, isSelected, onClick, isInRange = false }) => {
  const inlineSettings = useInlineSettings()
  const theme = useSelector((state: RootState) => state?.general?.theme)

  const bgColor = useMemo(() => {
    if (isSelected) return inlineSettings ? '#222222' : theme?.elementsColor
    if (isInRange) return '#dadada'
    return 'transparent'
  }, [isInRange, isSelected, inlineSettings, theme])

  return (
    <Box
      w="40px"
      h="40px"
      display="flex"
      alignItems="center"
      justifyContent="center"
      borderRadius="full"
      cursor="pointer"
      border="1px solid #dadada"
      bg={bgColor}
      color={isSelected ? 'white' : 'black'}
      onClick={onClick}
      fontWeight="bold"
    >
      <Text>
        <LocaleText text={day} />
      </Text>
    </Box>
  )
})
